<template>
	<main class="home-page">
		<HeroSection :isAuth="isAuth" />

		<WhyChooseUs />

		<BrowseSection />

		<ProductCarousel
			:isAuth="isAuth"
			:title="$t('Hot Deals Zone')"
			showArrows="false"
			:chosenItem="chosenItem"
			apiEndpoint="items/list"
			showAllLink="/products/all"
			@goToProduct="goToProduct"
			@addToCart="addToCart"
		/>

		<StartShoppingSection
			:isAuth="isAuth"
			@openSellSkinModal="openSellSkinModal"
			@openSignIn="openSignIn"
		/>
	</main>
</template>
<script>
import BrowseSection from '@/components/BrowseSection.vue';
import HeroSection from '@/components/HeroSection.vue';
import ProductCarousel from '@/components/ProductCarousel.vue';
import StartShoppingSection from '@/components/StartShoppingSection.vue';
import WhyChooseUs from '@/components/WhyChooseUs.vue';
import { mapGetters } from 'vuex';
export default {
	name: 'HomePage',
	components: {
		ProductCarousel,
		StartShoppingSection,
		WhyChooseUs,
		HeroSection,
		BrowseSection,
	},

	props: {
		chosenItem: {
			type: String,
		},
		currencySymbol: {
			type: String,
			required: true,
		},
		isAuth: {
			type: Boolean,
			required: true,
		},
		currencyCode: {
			type: String,
			required: true,
		},
		lang: {
			type: String,
			required: true,
		},
	},
	data: function () {
		return {
			saleProducts: [],
			newArrivals: [],
			activePanels: [],
			faq: [],
		};
	},
	computed: {
		...mapGetters('app', ['currentLanguage']),
	},
	watch: {
		currencyCode() {
			this.getNewArrivals();
			this.getSale();
		},
		lang() {
			this.getFaq();
		},
	},
	async mounted() {
		this.getSale();
		this.getNewArrivals();
		this.getFaq();
	},
	methods: {
		addToCart(item) {
			this.$emit('addToCart', item);
		},
		openSellSkinModal() {
			this.$emit('openSellSkinModal');
		},
		openSignIn() {
			this.$emit('openSignIn');
		},
		openSignUp() {
			this.$emit('openSignUp');
		},
		getFaq() {
			this.$http
				.get('faq')
				.then((res) => {
					this.faq = res.data.payload;
				})
				.catch(() => {});
		},
		getNewArrivals() {
			this.$http
				.get('items/list?new=true')
				.then((res) => {
					this.newArrivals = res.data.payload;
				})
				.catch(() => {});
		},
		getSale() {
			this.$http
				.get('items/list?sale=true')
				.then((res) => {
					this.saleProducts = res.data.payload;
				})
				.catch(() => {});
		},
		goToProduct(item) {
			this.$emit('goToProduct', item);
		},
		togglePanel(index) {
			if (this.isActivePanel(index)) {
				this.activePanels.splice(this.activePanels.indexOf(index), 1);
			} else {
				this.activePanels.push(index);
			}
		},
		isActivePanel(index) {
			return this.activePanels.includes(index);
		},
	},
};
</script>
